export default __webpack_public_path__ + "static/media/person_2@3x.c139f605.png";